module.exports = __webpack_public_path__ + "static/media/loader.f92aa781.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/loader.svg
// module id = 323
// module chunks = 0